import { Color, MediaBreakpoint } from 'root-constants'
import styled, { css } from 'styled-components'
import { Button } from '../../../components/Button'
import { baseMediaStyles, baseMediaStylesRfnd } from '../../../components/styles'
import Arrow from '../assets/images/sprite/right-white-arrow.svg'

type TProps = {
  isFrLocale?: boolean
  isNewWidthCohort?: boolean
  isDesktopWidth?: boolean
}

export const flowButtonPrimaryLabelCss = css`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 56px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Color.BLACK_SECONDARY};
  border-radius: 12px;
  padding: 0 52px;
  outline: none;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${Color.WHITE};
  cursor: pointer;
`

export const StyledFlowButton = {
  Button: styled(Button)<TProps>`
    ${({ isNewWidthCohort }) => (isNewWidthCohort ? baseMediaStylesRfnd : baseMediaStyles)};
    bottom: 55px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ isFrLocale }) =>
      isFrLocale &&
      `
      font-size: 18px;
      
    `};

    @media (min-width: ${MediaBreakpoint.MAX_PHONE}px) {
      width: ${({ isNewWidthCohort }) => !isNewWidthCohort && '290px'};
    }

    ${({ isDesktopWidth }) =>
      isDesktopWidth &&
      `
      @media (min-width: ${MediaBreakpoint.QUESTIONS_DESKTOP}px) {
        width: 398px;
      }
    `}
  `,
  ButtonFullWidth: styled(Button)<TProps>`
    ${flowButtonPrimaryLabelCss};
    cursor: pointer;
    border: none;

    ${({ isFrLocale }) =>
      isFrLocale &&
      `
      font-size: 18px;
      
    `}

    &:disabled {
      background-color: ${Color.BLACK_SECONDARY};
      opacity: 0.3;
      cursor: not-allowed;
    }
  `,
  IconLeft: styled.span`
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    & > svg {
      width: 24px;
      height: 24px;
    }
  `,
  IconRight: styled.span`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    & > svg {
      width: 24px;
      height: 24px;
    }
  `,
  ButtonText: styled.span<{ isLeadingIcon?: boolean; isLongLocale?: boolean }>`
    text-align: center;
    white-space: nowrap;
    padding-left: ${({ isLeadingIcon }) => isLeadingIcon ? '10px' : '0'};
    font-family: 'Inter';
    ${({ isLongLocale }) => isLongLocale && css`
      font-size: 14px;
    `}
  `,
  ArrowIcon: styled(Arrow)`
    width: 24px;
    height: 24px;
    ${(props) => (props.theme.dir === 'rtl' && css`
        transform: rotate(180deg);
        `)};
  `,
}
